import styled from 'styled-components';



export const Container = styled.div<{
  size: number
}>`
  flex-grow: ${(args) => args.size};
`
